import React from 'react';
import Backicon from '../../../shared/components/Backicon/Backicon';
import styles from "./hospitalaccess.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from '../../../shared/components/Header/Header';
import Input from '../../../shared/components/Input/Input';
import Button from '../../../shared/components/Button/Button';
import { Link } from 'react-router-dom';



const initialState = {
    department: "",
    name: "",
    hospitalId: "",
    password: "",
    departmentError: "",
    nameError: "",
    hospitalIdError: "",
    passwordError: "",
}
class HospitalAccess extends React.Component {
    state = {
        initialState
      };

      handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
      };

      validate = () => {
        let departmentError =  "";
        let nameError =  "";
        let hospitalIdError =  "";
        let passwordError =  ""; 

        if (!this.state.department) {
            departmentError = "Please Select Your field or Department";
          }
        if (!this.state.name) {
            nameError = "Name cannot be empty";
          }
        if (!this.state.hospitalId) {
            hospitalIdError = "Hospital ID cannot be empty";
          }
        if (!this.state.password) {
            hospitalIdError = "Please enter valid password";
          }

          if(
              departmentError || nameError || hospitalIdError || passwordError
          ) {
              this.setState({
                  departmentError,nameError,hospitalIdError,passwordError
              });
              return false;
          }

          return true;
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const isValid = this.validate();
        if (isValid) {
          console.log(this.state);
          this.setState(initialState);
        }
      };

    render(){
    return (
        <div className={styles.backgroundpic}>
            <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}/>
            <div className={basestyles.inputWidth}>
                <Header name="Hospital Verification" />
            <form onSubmit={this.handleSubmit}>

                <label className={styles.hospitalVerification}>Select the department or staff</label>
              <select
                className={styles.hospitalWorkType}
                name="Select the department"
                value={this.state.department}
            onChange={this.handleChange}
          
              >
                <option value="Department">
                Select The Department
                </option>
                <option value="Board member">
                  Board Member
                </option>
                <option value="Doctor">
                  Doctor
                </option>
                <option value="Surgeon">
                Surgeon
                </option>
                <option value="Clinical Staff">
                Clinical Staff
                </option>
              </select>
              <div className={styles.errors}>{this.state.departmentError}</div>

              <label className={styles.hospitalVerification}>Name</label>
              <Input
                placeholder="Name"
                type="text"
                name="Name"
                value={this.state.name}
                onChange={this.handleChange}
                />
              <div className={styles.errors}>{this.state.nameError}</div>
              <label className={styles.hospitalVerification}>Hospital ID</label>
              <Input
                placeholder="Hospital ID"
                type="text"
                name="HospitalID"
                value={this.state.hospitalId}
                onChange={this.handleChange}
                />
              <div className={styles.errors}>{this.state.hospitalIdError}</div>
                <label className={styles.hospitalVerification} >Password</label>
                <Input
                  placeholder="Password"
                  name="Password"
                  type="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  />
              <div className={styles.errors}>{this.state.passwordError}</div>
                  <Link to="/hospital/patient-details-record">
                  <Button
                    buttonName="Submit"
                    style={{
                        color: "white",
                        margin: "20px 15px 30px",
                        padding: "10px 10px",
                        width: "90%",
                        maxWidth: "500px",
                    }}> 
                  </Button>
                  </Link>
              </form>
            </div>
        </div>
    )
}
}

export default HospitalAccess;
